<!-- src/components/QuestionModal.vue -->
<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="open"
        class="fixed inset-0 z-50 flex items-center justify-center"
        @keydown.esc.prevent="handleEsc"
      >
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/60"
          @click="canClose ? emit('close') : null"
        ></div>

        <!-- Wrapper para respeitar o spacing do flowbite -->
        <div class="relative p-4 w-full max-w-md max-h-full z-10">
          <!-- Dialog -->
          <div
            ref="panelRef"
            class="relative rounded-lg shadow-sm focus:outline-none border border-[#222222] bg-white"
            role="dialog"
            aria-modal="true"
            :aria-labelledby="titleId"
          >
            <!-- Header -->
            <div
              class="flex items-center justify-between uppercase p-4 py-2 md:p-5 md:py-2 border-b rounded-t-lg border-[#222222]"
            >
              <h3
                :id="titleId"
                class="text-lg font-semibold text-black"
              >
                Nova questão
              </h3>

              <!-- botão de fechar | desativado -->
              <button
                v-if="canClose"
                type="button"
                class="text-gray-400 bg-transparent rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
                @click="emit('close')"
              >
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 14 14"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span class="sr-only">Fechar</span>
              </button>
            </div>

            <!-- Body -->
            <div class="p-3 py-2 md:p-5 md:py-2">
              <Questions />

              <!-- Rodapé -->
              <div class="flex items-center justify-center mt-2">
                <CreateButton
                  @click="submit"
                  :icon="PhListPlus"
                  :label="'Cadastrar'"
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref, watch } from 'vue'
import CreateButton from '@/components/Buttons/Create.vue'
import { PhListPlus } from '@phosphor-icons/vue'
import AfastamentoForm from '../Afastamento.vue'
import Questions from '../forms/questions.vue'

const props = defineProps({
  open: { type: Boolean, default: false },
  question: { type: Object, default: null }, // { id, title, prompt, time_seconds, time_label, required, options: [...] }
  canClose: { type: Boolean, default: false } // se quiser permitir fechar sem responder
})

const emit = defineEmits(['close', '  '])

const selectedId = ref(null)
const panelRef = ref(null)
const titleId = `question-title-${Math.random().toString(36).slice(2, 8)}`

function handleEsc () {
  if (props.canClose) emit('close')
}

function submit () {
  emit('submit', {
    questionId: null,
    optionId: selectedId.value,
    points: null
  })
  // Não fecha automaticamente: deixe o pai decidir (validar, salvar, etc.)
}

// foco inicial acessível
function focusPanel () {
  requestAnimationFrame(() => panelRef.value?.focus?.())
}

watch(
  () => props.open,
  (v) => v && focusPanel()
)
onMounted(() => props.open && focusPanel())
onBeforeUnmount(() => {
  /* nada por enquanto */
})
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.18s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
